import React from 'react';
import { useIntl } from 'react-intl';

import { FlexColumn, FlexRow, Gap } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';

import { messages } from '../messages';
import style from '../style.module.less';

/**
 * @typedef {import('react-intl').MessageDescriptor} MessageDescriptor
 */

/**
 * @param {object} props
 * @param {MessageDescriptor} props.title
 * @param {MessageDescriptor} props.description
 * @param {any} props.iconSrc - SVG icon source path
 * @returns {JSX.Element}
 */
export const BenefitCard = ({ title, description, iconSrc }) => {
  const intl = useIntl();

  return (
    <FlexRow className={style['benefit-card']} gap={Gap.Space24}>
      <FlexRow className={style['benefit-card-icon-row']}>
        <div className={style['benefit-card-icon-wrapper']}>
          <img alt={intl.formatMessage(messages.benefitCardAlt)} className={style['benefit-card-icon']} src={String(iconSrc)} />
        </div>
      </FlexRow>
      <FlexColumn gap={Gap.Space8}>
        <Text className={style['benefit-card-title']} textType={TextType.H3} value={title} />
        <Text className={style['benefit-card-description']} textType={TextType.Description} value={description} />
      </FlexColumn>
    </FlexRow>
  );
};
